import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import { CssBaseline, Stack, ThemeProvider } from '@mui/material';
import { RouterProvider } from 'react-router-dom';

import { theme as dsTheme, Toast as ToastProvider } from '@/design-system';
import { routes } from '@/routes';
import { useCustomTheme } from '@/styles/theme';

import { AppErrorBoundary } from './error-boundary/app-error-boundary';
import { MaintenanceGate } from './maintenance';
import { ReactQueryProvider } from './providers/react-query-provider';
import { SuiProvider } from './providers/sui-provider';

export const App = () => {
  const theme = useCustomTheme();

  return (
    <ReactQueryProvider>
      <EmotionThemeProvider theme={dsTheme}>
        <ThemeProvider theme={theme}>
          <ToastProvider>
            <CssBaseline />
            <AppErrorBoundary>
              <MaintenanceGate>
                <SuiProvider>
                  <Stack minHeight="100dvh">
                    <RouterProvider router={routes} />
                  </Stack>
                </SuiProvider>
              </MaintenanceGate>
            </AppErrorBoundary>
          </ToastProvider>
        </ThemeProvider>
      </EmotionThemeProvider>
    </ReactQueryProvider>
  );
};
